import React, { useEffect, useState, useRef } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import SEO from "../Seo";
import { ToastContainer, toast } from "react-toastify";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import { thirdparty } from "../..";

import VirtualizedSelect from "react-virtualized-select";

import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";

const roleManager = () => {
  let user_role_form_ref = useRef();
  const [fatchData, setFatchdata] = useState([]);
  const [formData, setFormData] = useState({
    role_name: "",
    status: 1,
  });

  const [userList, setUserList] = useState([]);
  const [userRoleForm, setUserRoleForm] = useState({
    id: 0,
    role: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChange_user_role = (e) => {
    const { name, value } = e.target;
    setUserRoleForm({
      ...userRoleForm,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await thirdparty.post("/roles", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201) {
        setFormData({
          ...formData,
          role_name: "",
        });
        toast.success("Data Added successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        fetchData();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleUserRoleSubmit = async (e) => {
    e.preventDefault();
    let userFormData = { role: userRoleForm.role };
    try {
      const response = await thirdparty.put(
        `/user/update_patient/${userRoleForm.id}`,
        userFormData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setUserRoleForm({
          ...userRoleForm,
          id: 0,
          role: 0,
        });
        toast.success("Roles updated successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        fetchUser();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await thirdparty.get("/roles"); // Update the API endpoint

      if (response.status === 200) {
        setFatchdata(response.data);
        // setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchUser = async () => {
    try {
      const response = await thirdparty.get("/user/get_user_list"); // Update the API endpoint

      if (response.status === 200) {
        setUserList(response.data.data);
        // setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleDelete = async (id) => {
    let confirmation = confirm("Are you sure to delete this item?");
    if (!confirmation) {
      return;
    }
    try {
      const response = await thirdparty.delete(`/roles/${id}`); // Update the API endpoint

      if (response.status === 200) {
        fetchData(); // Fetch updated data after deletion
        toast.success("Data Deleted successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error(`Error deleting item with ID ${id}:`, error.message);
    }
  };

  const handleRolePermission = (user_id, role_id) => {
    setUserRoleForm(...userRoleForm, {
      id: user_id || 0,
      role: role_id || 0,
    });

    window.scrollTo({
      behavior: "smooth",
      top: user_role_form_ref.current.offsetTop,
    });
  };

  useEffect(() => {
    fetchData();
    fetchUser();
  }, []);

  return (
    <div className="fixed-left">
      <SEO
        title="Set User Role "
        description="Set User Role - United Hospital"
        pathSlug="/admin/addRole"
        keywords="Set New User Role"
      />
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper row">
              <div className="col-md-4 col-sm-12">
                <div className="card m-b-20">
                  <h5 className="card-header">Add New Role</h5>

                  <div className="card-body">
                    <form
                      id="adddepartmentform"
                      className="needs-validation"
                      noValidate
                      onSubmit={handleSubmit}
                    >
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Role Title</label>
                            <input
                              type="text"
                              form_type="role_create"
                              className="form-control"
                              name="role_name"
                              id="role_name"
                              value={formData.role_name}
                              onChange={handleChange}
                              required
                              placeholder="Role Title"
                            />
                          </div>
                          <div className="form-group float-right">
                            <button
                              type="submit"
                              className="btn waves-effect waves-light"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="card m-b-20">
                  <h5 className="card-header">Role List</h5>
                  <div className="card-body">
                    <table className="table" width="100%">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Title</th>
                          <th scope="col">Status</th>
                          <th scope="col" className="text-right">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {fatchData.length > 0 ? (
                          fatchData.map((item, index) => (
                            <tr key={item.id}>
                              <th scope="row">{index + 1}</th>
                              <td>{item.role_name}</td>
                              <td>
                                {item.status == 1 ? "Active" : "Inactive"}
                              </td>
                              <td>
                                <h5
                                  className="mt-2"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-end",
                                    columnGap: "10px",
                                    rowGap: "10px",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <a
                                    href={"/admin/role-permission/" + item.id}
                                    role_id={item.id}
                                  >
                                    <i className="fa fa-pencil-square "></i>
                                  </a>
                                  <a onClick={() => handleDelete(item.id)}>
                                    <i className="fa fa-trash"></i>
                                  </a>
                                </h5>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <th colSpan={3}>Data Not Found</th>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-sm-12">
                <div className="card m-b-20">
                  <h5 className="card-header">User Role Setup</h5>
                  <div className="card-body">
                    <form
                      id="user_role_setup"
                      className="needs-validation"
                      noValidate
                      onSubmit={handleUserRoleSubmit}
                      ref={user_role_form_ref}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>User</label>
                            <VirtualizedSelect
                              id="id"
                              name="author_id"
                              className="form-control custom_select_search"
                              placeholder="Select User"
                              options={userList.map((item, index) => ({
                                label: item.fullname + " (" + item.email + ")",
                                value: item.id,
                              }))}
                              value={userRoleForm.id}
                              onChange={(selectValue) =>
                                setUserRoleForm({
                                  ...userRoleForm,
                                  id: selectValue.value,
                                })
                              }
                            ></VirtualizedSelect>
                            {/* <select
                              className="form-control"
                              name="id"
                              id="author_id"
                              value={userRoleForm.id}
                              onChange={handleChange_user_role}
                              placeholder="select User"
                            >
                              <option readOnly>Select User</option>
                              {userList.length > 0
                                ? userList.map((user) => (
                                    <option value={user.id} key={user.id}>
                                      {user.fullname}
                                    </option>
                                  ))
                                : null}
                            </select> */}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Role</label>
                            <VirtualizedSelect
                              id="author_id"
                              name="role"
                              className="form-control custom_select_search"
                              placeholder="Select Role"
                              options={fatchData.map((item, index) => ({
                                label: item.role_name,
                                value: item.id,
                              }))}
                              value={userRoleForm.role}
                              onChange={(selectValue) =>
                                setUserRoleForm({
                                  ...userRoleForm,
                                  role: selectValue.value,
                                })
                              }
                            ></VirtualizedSelect>
                            {/* <select
                              className="form-control"
                              name="role"
                              id="author_id"
                              value={userRoleForm.role}
                              onChange={handleChange_user_role}
                              placeholder="select role"
                            >
                              <option readOnly>Select Role</option>
                              {fatchData.length > 0
                                ? fatchData.map((role) => (
                                    <option value={role.id} key={role.id}>
                                      {role.role_name}
                                    </option>
                                  ))
                                : null}
                            </select> */}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group float-right">
                            <button
                              type="submit"
                              className="btn waves-effect waves-light"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="card m-b-20">
                  <h5 className="card-header">User List</h5>
                  <div className="card-body">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Role</th>
                          <th scope="col">Name</th>
                          <th scope="col">Phone</th>
                          <th scope="col">Email</th>
                          <th scope="col" className="text-right">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {userList.length > 0 ? (
                          userList.map((item, index) => (
                            <tr key={item.id}>
                              <th scope="row">{index + 1}</th>
                              <td>{item.roles ? item.roles.role_name : "-"}</td>
                              <td>{item.fullname}</td>
                              <td>{item.phone}</td>
                              <td>{item.email}</td>
                              <td>
                                <h5
                                  className="mt-2"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-end",
                                    columnGap: "10px",
                                    rowGap: "10px",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <a
                                    onClick={() =>
                                      handleRolePermission(item.id, item.role)
                                    }
                                    title="Set Role"
                                  >
                                    <i className="fa fa-pencil-square "></i>
                                  </a>
                                </h5>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <th colSpan={3}>Data Not Found</th>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default roleManager;



// WEBPACK FOOTER //
// ./src/component/admin/roleManager.js